import React from "react";
import { Col, Row } from 'react-bootstrap';
import Langs from '../../app/lang/langs';
import { config } from '../../app/utils/config';
import styles from './Permissions.module.css';
import PermissionButton from './PermissionButton';

export default function PermissionRow({ scope, scopeType, role, activePermissions, onPermissionChange }) {

    const isGlobal = scopeType === "global";
    const allowTeamRemove = !isGlobal && (scope === "evaluations" || scope === "ventr" || scope === "warnings");
    const disallowGlobalRemove = isGlobal && (scope === "news" || scope === "vsecurite");
    const permissionTypes = isGlobal
        ? [
            ...(disallowGlobalRemove ? [] : [config.permissionTypes.remove]),
            config.permissionTypes.view,
            config.permissionTypes.edit,
        ]
        : [
            ...(allowTeamRemove ? [config.permissionTypes.remove] : []),
            config.permissionTypes.view,
            config.permissionTypes.edit,
            config.permissionTypes.view_all,
            config.permissionTypes.edit_all,
        ];

    const labelColProps = isGlobal
        ? { lg: 4, xl: 4, xxl: 4 }
        : { lg: 4, xl: 4, xxl: 4 };
    const buttonColProps = isGlobal
        ? { lg: 8, xl: 8, xxl: 8 }
        : { lg: 8, xl: 8, xxl: 8 };

    // For scopes where view is the implicit floor (no "Remove" option),
    // show View as active by default when no other tier is selected.
    const editActive = !!activePermissions[config.permissionTypes.edit]?.includes(scope)
    const viewActive = !!activePermissions[config.permissionTypes.view]?.includes(scope)

    const isTypeActive = (type) => {
        if (type === config.permissionTypes.view && disallowGlobalRemove && !editActive && !viewActive) {
            return true
        }
        return !!activePermissions[type]?.includes(scope)
    }

    return (
        <Row className={styles.permissionRow}>
            <Col {...labelColProps} className={isGlobal ? styles.labelGlobal : styles.labelTeam}>
                <Langs str={scope} />
            </Col>
            <Col {...buttonColProps} className={styles.buttonGroup}>
                {permissionTypes.map(type => (
                    <PermissionButton
                        key={type}
                        type={type}
                        isActive={isTypeActive(type)}
                        onClick={() => onPermissionChange(role, scopeType, scope, type)}
                        useLocalize={!isGlobal && type !== config.permissionTypes.remove}
                    />
                ))}
            </Col>
        </Row>
    );
}
